import { render } from "./MarketingPreferences.vue?vue&type=template&id=37ce6b51"
import script from "./MarketingPreferences.vue?vue&type=script&lang=js"
export * from "./MarketingPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__